export default __webpack_public_path__ + "static/changhui.lee-3f5ae1982877d8edf7f6a7a2b1785270.png";